import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'gold' | 'forest' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'gold',
  size = 'lg',
  arrow = false,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const variants = {
    gold: 'bg-gold text-forest-dark shadow-[0_10px_24px_rgba(215,223,225,.2)] hover:bg-white',
    forest: 'bg-earth text-forest-dark shadow-[0_10px_24px_rgba(154,203,49,.22)] hover:bg-[#b8e24e]',
    outline: 'border-2 border-gold bg-transparent text-gold hover:bg-gold hover:text-forest-dark'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-4 text-sm sm:px-8 sm:text-base'
  };
  return <button className={`inline-flex items-center justify-center gap-2 rounded-xl font-extrabold transition duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 disabled:cursor-not-allowed disabled:opacity-60 ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-292" data-mp="33a2xxy317o2">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-293" data-mp="erqz38qvuuq9" />}
    </button>;
}